export default [
  {
    title: 'Customers',
    section: 'store',
    order: 3,
    icon: 'supervisor_account',
    items: [
      {
        title: 'All Customers',
        component: 'customers',
        section: 'store'
      },
      {
        title: 'Groups',
        component: 'groups',
        section: 'store'
      }
    ]
  }
]
